import { createSelector } from 'reselect';

const getTranscript = (state) => state.transcript;
const getTranscriptBlocks = (state) => state.transcript.data.blocks;
const getEdits = (state) => state.transcript.editedUtterances;
const getInvalidUtteranceIds = (state) => state.transcript.invalidUtteranceIds;

const transcriptFormatter = (blocks, ids) => {
  const format = ids.reduce((prev, id) => {
    const utterances = blocks[id].utterances;
    const result = [...prev, { id, utterances }];
    return result;
  }, []);

  return format;
};

const createBlockIds = (transcript) => {
  if (!transcript.data || !transcript.data.blocks) {
    return [];
  }

  return Object.keys(transcript.data.blocks);
};

const toArray = (obj) => {
  if (!obj) {
    return [];
  }

  const keys = Object.keys(obj);
  return keys.map((key) => obj[key]);
};

export const getUtterances = (state) => ({
  ...state.transcript.data.utterances,
  ...state.transcript.editedUtterances
});

export const getWebinarTranscriptLanguageCode = (state) => state.transcript?.data?.language || 'en-US';

export const getBlockIds = createSelector(
  getTranscript,
  createBlockIds
);

export const getEditedUtterances = createSelector(
  getEdits,
  toArray
);

export const getUtterancesArray = createSelector(
  getUtterances,
  toArray
);

export const getTranscriptFormat = createSelector(
  [getTranscriptBlocks, getBlockIds],
  transcriptFormatter
);

export const getIsSaveDisabled = createSelector(
  [getEditedUtterances, getInvalidUtteranceIds],
  (edits, invalidUtterances) => (!edits.length || !!invalidUtterances.length)
);
